import React, { FC } from 'react';
import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import AuthenticationStateHandler from './components/organisms/AuthenticationStateHandler';
import { createBrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom';
import { AuthenticationProvider, Home, Loading, Login, MainMenuLayout } from './components';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './theme/themes/mytheme/theme.scss';
import 'primeflex/primeflex.scss';
import { WalletList } from './components/pages/WalletsList';
import { DemoCredentialsForm } from './components/pages/DemoCredentialsForm';
import { DemoCredentialsList } from './components/pages/DemoCredentialsList';
import { useAppDispatch } from './state';


export const AppRoutes: FC = () => {
    const dispatch = useAppDispatch();


    const router = createBrowserRouter([
        {
            path: "*", element: <Root/>, handle: {
                crumb: () => "Home"
            }
        },
    ]);

    function Root() {
        return (
            <AuthenticationProvider>
                <AuthenticationStateHandler
                    loading={<Loading/>}
                    unAuthenticated={
                        <Routes>
                            <Route path="/" element={<MainMenuLayout/>}>
                                <Route path="/" element={<Login/>}/>
                                <Route path="*" element={<Login/>}/>
                            </Route>
                        </Routes>
                    }
                    authenticated={
                        <Routes>
                            <Route path="/" element={<MainMenuLayout/>}>
                                <Route path="/" element={<WalletList/>}/>
                                <Route path="*" element={<WalletList/>}/>
                                <Route path="/wallets" element={<WalletList/>}/>
                                <Route path="/demo-credentials" element={<DemoCredentialsForm/>}/>
                                <Route path="/demo-credentials-list" element={<DemoCredentialsList/>}/>
                            </Route>
                        </Routes>
                    }
                />
            </AuthenticationProvider>
        );
    }

    return <RouterProvider router={router}/>;
}
